/**
 * Soft Motion LP: stack shopify sections by DOM order.
 * Later sections get higher z-index so they scroll over sticky pins
 * (e.g. keep exploring) regardless of template order.
 */
(function () {
  var running = false;

  function applySoftMotionSectionStacking() {
    if (running) return;
    running = true;

    try {
      var main =
        document.getElementById('MainContent') ||
        document.querySelector('[role="main"]') ||
        document.querySelector('main') ||
        document.body;

      if (!main) return;

      var sections = main.querySelectorAll(':scope > .shopify-section');
      if (!sections.length) {
        sections = main.querySelectorAll('.shopify-section');
      }

      var stackIndex = 0;

      Array.prototype.forEach.call(sections, function (section) {
        // Invisible helper only loads this script — keep it out of the stack
        if (section.classList.contains('ls-soft-motion-section-stack')) {
          section.style.zIndex = '0';
          return;
        }

        // Fixed subnav must sit above all stacked content sections (below site header)
        if (section.classList.contains('ls-sticky-anchor-menu-section')) {
          section.style.zIndex = '1000';
          section.style.position = 'relative';
          return;
        }

        stackIndex += 1;
        section.style.zIndex = String(stackIndex);

        var position = window.getComputedStyle(section).position;
        if (position === 'static') {
          section.style.position = 'relative';
        }
      });
    } finally {
      running = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySoftMotionSectionStacking);
  } else {
    applySoftMotionSectionStacking();
  }

  document.addEventListener('shopify:section:load', applySoftMotionSectionStacking);
  document.addEventListener('shopify:section:reorder', applySoftMotionSectionStacking);
  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(applySoftMotionSectionStacking, 0);
  });
})();
